export default "__VITE_ASSET__DePM_g84__"